/* eslint-disable react/require-default-props */
/* eslint-disable react/no-danger */
import React from 'react';
import { translate } from '@utils/i18n';
import { IssueStatusEnum } from '../../types';
import ManagerNote from './ManagerNote';
import IssueLayout from './IssueLayout';
import './styles.scss';
export default function AssetCountChangeCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, readOnly = false }) {
    var _a, _b;
    const status = issue.status || IssueStatusEnum.Detected;
    // Handler functions for issue actions
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true);
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const handleNoteChange = (note) => {
        onUpdateIssue(issue.id, status, issue.markedForSuggestion, note);
    };
    return (React.createElement(IssueLayout, { issueType: "asset_count_change", status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, markedForSuggestion: issue.markedForSuggestion },
        React.createElement(React.Fragment, null,
            issue.issueData.isAggregate && (React.createElement("p", { dangerouslySetInnerHTML: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    __html: translate('asset_count_change_aggregate_description', {
                        namespace: 'features.iim_review.issue_card',
                        inspectableType: issue.issueData.inspectableClassName,
                        changeDirection: issue.issueData.assetCountChange > 0 ? 'increased' : 'decreased',
                        changeAmount: Math.abs(issue.issueData.assetCountChange),
                        priorInspectionId: issue.issueData.priorInspection.inspectionId,
                        priorInspectionFreq: issue.issueData.priorInspection.frequency,
                        priorInspectionDate: new Date(issue.issueData.priorInspection.inspectedDate).toLocaleDateString()
                    })
                } })),
            !issue.issueData.isAggregate && (React.createElement("p", { dangerouslySetInnerHTML: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    __html: translate('asset_count_change_description', {
                        namespace: 'features.iim_review.issue_card',
                        inspectableName: ((_a = issue.inspectable.data) === null || _a === void 0 ? void 0 : _a.name) || issue.inspectable.type,
                        changeDirection: issue.issueData.assetCountChange > 0 ? 'increased' : 'decreased',
                        changeAmount: Math.abs(issue.issueData.assetCountChange),
                        priorInspectionId: issue.issueData.priorInspection.inspectionId,
                        priorInspectionFreq: issue.issueData.priorInspection.frequency,
                        priorInspectionDate: new Date(issue.issueData.priorInspection.inspectedDate).toLocaleDateString()
                    })
                } })),
            issue.markedForSuggestion && (!readOnly || ((_b = issue.managerNote) === null || _b === void 0 ? void 0 : _b.trim())) && (React.createElement("div", { className: "issue-card__body" },
                React.createElement(ManagerNote, { note: issue.managerNote || '', onNoteChange: handleNoteChange, disabled: readOnly }))))));
}
